import React from "react";
import Datepicker from "react-tailwindcss-datepicker";

const DateInput = ({
  label,
  value,
  onChange,
  name,
  required = false,
  error,
  className,
  useRange = false,
}) => {
  return (
    <div className={`flex flex-col ${className}`}>
      {label && (
        <label
          htmlFor={name}
          className="text-gray-700 mb-2 font-regular flex items-center text-sm"
        >
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <Datepicker
        primaryColor="blue"
        value={value}
        onChange={(newValue) => (onChange ? onChange(name, newValue) : null)}
        asSingle={true} // Set to true if you only need a single date
        inputClassName={`w-full font-regular text-sm px-4 py-2 border rounded-md text-gray-700 focus:outline-none focus:ring-2 focus:ring-primary ${
          error ? "border-red-500" : "border-gray-300"
        }`}
        required={required}
        displayFormat={"MM/DD/YYYY"} // Customize display format
        useRange={useRange} // Change to true if you want a range picker
      />
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};

export default DateInput;
